/**
 * EasyData representation of GUID.
 */
var EasyGuid = /** @class */ (function () {
    function EasyGuid() {
    }
    /**
     * Generates new GUID.
     * @returns The string representation of GUID.
     */
    EasyGuid.newGuid = function () {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    return EasyGuid;
}());
export { EasyGuid };
//# sourceMappingURL=easy_guid.js.map